<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
      label-position="top"
    >
      <h6 style="color: #101010" class="mb-1">
        {{ $l('form_header_customer') || '客户信息' }}
      </h6>
      <div class="d-flex align-items-end">
        <div
          class="d-flex"
          style="margin-right: 10px;padding-top: 16px;padding-bottom: 10px;"
        >
          <el-avatar shape="square" :src="formData.bigImageUrl" :size="64">
            <span style="font-size: 20px;">LOGO</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="16">
            <el-form-item :label="$l('form_label_custName') || '客户公司名称'">
              <el-input v-model="formData.custName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_custShortName') || '客户简称'">
              <el-input v-model="formData.custShortName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <h6 style="color: #101010" class="mt-3 mb-1">
        {{ $l('form_header_user') || '团队成员' }}
      </h6>
      <div class="d-flex align-items-end">
        <div
          class="d-flex"
          style="margin-right: 10px;padding-top: 16px;padding-bottom: 10px;"
        >
          <el-avatar shape="square" :src="formData.memImgUrl" :size="64">
            <span style="font-size: 30px;">U</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_userName') || '团队成员'">
              <el-input v-model="formData.userName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_userPost') || '职务'">
              <el-input v-model="formData.userPost" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_mobileNumber') || '联系电话'">
              <el-input v-model="formData.mobileNumber" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item :label="$l('form_label_emailAddress') || '邮件地址'">
            <el-input v-model="formData.emailAddress" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_fixedTelephone') || '固定电话'">
            <el-input v-model="formData.fixedTelephone" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_orgName') || '所属公司'">
            <el-input v-model="formData.orgName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_depFullName') || '所属部门'">
            <el-input v-model="formData.depFullName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="flex-grow-1">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_bizTeamRoles') || '业务团队角色'"
            prop="bizTeamRoles"
          >
            <dict-select
              v-model="formData.bizTeamRoles"
              :placeholder="
                $l('form_placeholder_bizTeamRoles') || '请选择业务团队角色'
              "
              url="/digitalCenter/common/dict/system"
              :body="{ dictType: 'bizTeamRoles' }"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('form_label_custCategory') || '负责品类'">
            <dict-select
              v-model="formData.custCategoryCodeList"
              url="/digitalCenter/master/customer/category/select"
              :body="{ custCode: formData.custCode || 'xxx' }"
              :placeholder="
                $l('form_placeholder_custCategory') || '请选择负责品类'
              "
              clearable
              filterable
              multiple
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_userResponsibilities') || '业务职责说明'"
          >
            <el-input
              v-model="formData.userResponsibilities"
              :placeholder="
                $l('form_placeholder_userResponsibilities') ||
                  '请输入业务职责说明'
              "
              type="textarea"
              maxlength="200"
              :rows="4"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ this.$l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ this.$l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    custBizTeamSetCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        bizTeamRoles: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bizTeamRoles') || '请选择业务团队角色',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custBizTeamSetCode) return
      const res = await this.$api
        .masterCustomerBizTeamSetDetailApi({
          custBizTeamSetCode: this.custBizTeamSetCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBizTeamSetUpdateApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
